import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { authClient } from '@/api/auth';
import { openCommandPalette } from '@/components/CommandPalette';
import { Search } from 'lucide-react';

export function TopBar({ title }: { title?: string }) {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);

  async function handleLogout() {
    await authClient.signOut();
    setUser(null);
    window.location.href = '/login';
  }

  return (
    <header style={{
      height: 56,
      background: '#fff',
      borderBottom: '1px solid #e8e8e8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 24px',
      flexShrink: 0,
    }}>
      <span style={{ fontWeight: 600, fontSize: 15 }}>{title}</span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, fontSize: 13 }}>
        {/* Universal search — same palette as Ctrl-K, but discoverable */}
        <button
          onClick={openCommandPalette}
          aria-label="Search"
          title="Search jobs, assets, items, clients"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 30,
            height: 30,
            border: 'none',
            borderRadius: 7,
            cursor: 'pointer',
            background: 'transparent',
            color: '#666',
          }}
        >
          <Search size={17} strokeWidth={2.2} />
        </button>

        <span style={{ width: 1, height: 22, background: '#e8e8e8' }} />

        <Link
          to="/settings/notifications"
          title="Notification settings"
          style={{ color: '#666', textDecoration: 'none' }}
        >
          {user?.name} <span style={{ color: '#aaa', fontSize: 11 }}>({user?.role})</span>
        </Link>
        <button
          onClick={handleLogout}
          style={{
            border: '1px solid #ddd',
            borderRadius: 6,
            padding: '4px 12px',
            cursor: 'pointer',
            background: 'transparent',
            fontSize: 12,
            color: '#444',
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
